import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { fetchPOToVendorDateUpdate,updateDateforVendor,fetchPOToVendorDateUpdateParams } from "../../../api/vendor";

import { toast } from "react-toastify";
import dayjs from "dayjs";
import SweetAlert from "react-bootstrap-sweetalert";
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import { useDispatch } from "react-redux";

const UpdateVendorDate = () => {

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Vendor Dispatch Plan'))

    const [approvalrows, setApprovalrows] = useState([]);
    const [gridLoad, setGridLoad] = useState(false);
    const [vendorListLoad, setVendorListLoad] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
 
    const [savedItem, setSavedItem] = useState(false);
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const [isPOGenerationSuccess, setIsPOGenerationSuccess] = useState(false);
    const [isGeneratePOLoading, setGeneratePOLoading] = useState(false);

    //Ambapika
    const [isMount, setIsMount] = useState(true);
    const [givenDate, setGivenDate] = useState(null)
    const [remarks, setRemarks] = useState(null)
    const [poOptions, setPoOptions] = useState([]);
    const [selectedPo, setSelectedPo] = useState(null);
    const [errors, setErrors] = useState({
        dateType: false,
        date: false,
    });  
    

    const handleIdSelection = (e, value) => {
        let set = new Set(selectedIds);

        if(e.target.checked && !set.has(value)){
            set.add(value);
        } else if (!e.target.checked && set.has(value)){
            set.delete(value);
        }

        setSelectedIds(Array.from(set));
        setSelectedValue(null);
        setSelectedDate(null);
    }

    

    document.title = "Dashboard | Procurement Dashboard";
       const [showList, setShowList] = useState(false);
    const [dateTypeOptions, setDateTypeOptions] = useState([
      
        {
            label: 'Proposed date',
            value: 'proposed_date_update'
        },
        {
            label: 'Last modified date',
            value: 'modified_date_update'
        },
        {
            label: 'Actual date',
            value: 'actual_date_update'
        },
    ]);




    const toggleList = () => {
        setShowList(!showList);
    };
    const [rows, setRows] = useState([
        {
            productName: '',
            quantity: '',
            value: ''
        }
    ])
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const openModal = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };
    const [generateModal, setGenerateModal] = useState(false)
    const closeGenerateModal = () => {
        setGenerateModal(false);
        setSavedItem(false);
    }

    const handleCheckAll = (e) => {
        let isChecked = e.target.checked;
        let arr = [];
        if(isChecked){
            if (approvalrows.length === 0) {
                toast.error('No items are currently selected.');
                return;
              }
            arr = approvalrows.map(el => el.id);
            setSelectedIds(arr);    
        } else {
            setSelectedIds(arr);
        }
    }

    const columns = [
        {
            field: 'Sl_No', headerName: (<div><Checkbox onChange={(e) => handleCheckAll(e)} /><span>SL.No</span></div>),
            // width: 100,
            sortable: false,
            resizable: false,
            flex: 1,
            renderCell: (params) => {
                return <div><Checkbox checked={new Set(selectedIds).has(params.row.id)} onChange={(e) => handleIdSelection(e, params.row.id)} /><span>{params.value}</span></div>;
            },
        },
        {
            field: 'Product_Name',
            headerName: 'Product Name',
            headerClassName: 'break-header',
            cellClassName: 'product_name_wrap',
            // width: 160,
            flex: 1,
            sortable: false,
            resizable: false,
            editable: true,
            renderCell: (params) => {
                const productName = params.value;
                return (
                    <div style={{ cursor: 'pointer' }}>
                        {productName}
                    </div>
                );
            },
        },
        {
            field: 'Quantity',
            headerName: 'Quantity',
            headerClassName: 'break-header',
            sortable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 0.7,
            //   width: 160,
        },
        {
            field: 'vendor_name',
            headerName: 'Vendor Name',
            sortable: false,
            resizable: false,
            //   cellClassName: 'product_name_wrap center-aligndata ',
            //   width: 160,
            flex: 1,
            // width: 160,

        },
        {
            field: 'payment_term',
            headerName: 'Payment Term',
            headerClassName: 'break-header',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            // width: 160,
        },
        {
            field: 'erp_po_no',
            headerName: 'PO NUMBER',
            sortable: false,
            resizable: false,
            //   cellClassName: 'product_name_wrap center-aligndata ',
            //   width: 160,
            flex: 1,
            // width: 160,

        },
        {
            field: 'proposed_date',
            headerName: 'Proposed Date',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            // width: 160,

        },
        {
            field: 'last_modified_date',
            headerName: 'Last modified date',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            // width: 160,

        },
        {
            field: 'actual_date',
            headerName: 'Actual date',
            headerClassName: 'break-header',
            sortable: false,
            resizable: false,
            // headerAlign: 'center',
            // cellClassName: 'center-aligndata',
            flex: 1,
            // width: 160,

        },
    ];

    const fetchPOList = async (value='')=>{
        try {
            setIsMount(false)
            let response
            if(value !== ''){
                  response =  await fetchPOToVendorDateUpdateParams(value)

            }
            else {

                 response =  await fetchPOToVendorDateUpdate()
            }
            let count =1
            if(response.statusCode === 200 && response.data.polist.length >0){
                const formattedProducts = response.data.polist.flatMap((product, index) =>
                    product.procurementErpPOProducts.map((poProduct, poIndex) => ({
                        id: poProduct.id,
                        erp_po_product_id: poProduct.id,
                      Sl_No: count ++,
                      Product_Name: poProduct.item_name,
                      Quantity: poProduct.OQORDERED,
                      vendor_name: poProduct.VDNAME,
                      payment_term: product.procurementPOGenerate[0]['procurementPaymentOpt'].label,
                        erp_po_no: product.PONUMBER,
                        erp_po_id: product.id,
                        actual_date: poProduct.actual_date,
                        proposed_date: poProduct.proposed_date,
                        last_modified_date: poProduct.last_updated_date                
                    }))
                );
          
                  setApprovalrows(formattedProducts);
                  setPoOptions(response.data.poOptions)
            }
            else{
                setApprovalrows([]);

            }

        }
        catch(error){
            console.error('Error in fetching po product list for vendor date update:', error);
            toast.error('Something went wrong')
        }
    }
    useEffect(()=>{
        if(isMount){
            fetchPOList()
        }
    },[isMount])

    const [selectedValue, setSelectedValue] = useState(null);
    const [selectedDateType, setSelectedDateType] = useState(null);

    const [selectedDate, setSelectedDate] = useState(null);

    const handleGeneratePOClick = async () => {
        const payloadObj={}
        if (selectedIds.length < 1) {
            toast.info("Select at least 1 item for Dispatch Plan");
            return;
        }
        let formIsValid = true;
        if(!selectedDateType){
            setErrors(prev => ({ ...prev, dateType: true }));

             formIsValid = false;

        }
        if(!givenDate){
            setErrors(prev => ({ ...prev, date: true }));

            formIsValid = false;
        }
        if(formIsValid){

            const selectedRows = approvalrows.filter(row => selectedIds.includes(row.id));
            const errorMessages = [];
            selectedRows.forEach(row => {
                if (selectedDateType.value === 'actual_date_update') {
                    if (!row.proposed_date || !row.last_modified_date) {
                        errorMessages.push('For Actual date update, Proposed Date and Last Modified Date must be present for all selected records.');
                    }
                    if (row.actual_date) {
                        errorMessages.push('Actual date is already present for any record');
                    }
                } else if (selectedDateType.value === 'proposed_date_update') {
                    if (row.actual_date) {
                        errorMessages.push('For Proposed Date update, Actual Date  must be empty for all selected records.');
                    }
                    if (row.proposed_date) {
                        errorMessages.push('Proposed Date is already present for each selected record for Proposed Date update.');
                    }
                } else if (selectedDateType.value === 'modified_date_update') {
                    if (!row.proposed_date) {
                        errorMessages.push('Proposed Date is required for each selected record for Last Modified Date update.');
                    }
                    if (row.actual_date) {
                        errorMessages.push('For Last Modified Date update, Actual Date and Last Modified Date must be null for all selected records.');
                    }
                }
            });
            if (errorMessages.length > 0) {
                toast.error(errorMessages.join(' '));
                return;
            }
            let arr = selectedIds.map(el => approvalrows.find(item => item.id === el));
     
            const selectedRecords = arr.map(item => ({
                erp_po_product_id: item.erp_po_product_id,
                erp_po_id: item.erp_po_id,
            }));
    
            if(selectedRecords.length > 0){
    
                payloadObj.items = selectedRecords
            }
            if(selectedDateType){
                payloadObj.type = selectedDateType.value
            }
            if(givenDate){
                payloadObj.date = dayjs(givenDate).format('YYYY-MM-DD')
    
            }
            if(remarks){
                payloadObj.remarks = remarks
            }
    
            
    
        
            try {
                setGeneratePOLoading(true);
                const response = await updateDateforVendor(payloadObj);
        
                if (response.statusCode === 200) {
                    setIsPOGenerationSuccess(true);
                }
            } catch (err) {
                setIsPOGenerationSuccess(false);
                console.log(err);
            } finally {
                fetchPOList()
                setIsOpenSweetAlert(true);
    
                closeGenerateModal();
                closeModal();
                setGeneratePOLoading(false);
            }
        }
    };



    const handleSweetAlertConfirm = () => {
        setIsOpenSweetAlert(false);
    };
    const handleDateTypeChange = (event, value) => {
        setSelectedDateType(value);
        setErrors(prev => ({ ...prev, dateType: !value }));

      };
    const handleDateChange = (date) => {
        setGivenDate(date);
        setErrors(prev => ({ ...prev, date: !date }));

    };
    const handleRemarksChange = (event) => {
        setRemarks(event.target.value);
    };
    const handlePoChange = (event, value) => {
        setSelectedPo(value);
        if (value) {
        //   fetchPODetails(value.value);
        fetchPOList(value.value)

        } else {
            fetchPOList()
        }
      };
      const fetchPODetails = (erp_po_id) => {
        const selectedPOData = approvalrows.filter((item) => item.erp_po_id === erp_po_id);
        if (selectedPOData) {
          const rows = selectedPOData.map((item, index) => ({
            Sl_No: index + 1,
            ...item
          }));
          setApprovalrows(rows);
        } else {
          setApprovalrows([]);
        }
        setSelectedIds([])

      };
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div className="d-flex align-items-center gap-2">
                                <h4 className="mb-0 requisition_text">Vendor Date Update</h4>
                                <div>
                                    <Autocomplete
                                    className="data_field"
                                    id={`vendor-po-list`}
                                    sx={{ width: 230 }}
                                    options={poOptions}
                                    value={selectedPo}
                                    getOptionLabel={(option) => option.label}
                                    onChange={handlePoChange}
                                    renderInput={(params) => <TextField {...params} label="Search by PO Number" />}
                                    />

                                </div>
                            </div>
                                <div className="d-flex align-items-center gap-2">
                                    {/* <div> 
                                     <Autocomplete
                                        className="invoice_selectfield"
                                        disablePortal
                                        id="combo-box-demo"
                                        options={dateTypeOptions}
                                        value={selectedDateType}
                                        onChange={handleDateTypeChange}
                                        getOptionLabel={(option) => option.label}
                                        sx={{ width: 200,background:'white' }}
                                        renderInput={(params) => <TextField {...params} label="Choose date type" />}
                                    />
                                        {errors.dateType && <div style={{ color: 'red' }}> Date type is required</div>}

                                    </div> */}
                                    <div style={{ cursor: 'pointer' }}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                             id={`type-date`}
                                             className='invoice_datepicker'
                                                label=" Choose Date"
                                              value={givenDate}
                                              onChange={handleDateChange}

                                            sx={{ width: 200,background:'white' }}
                                            />
                                        </LocalizationProvider>
                                        {errors.date && <div style={{ color: 'red' }}> Date is required</div>}
                                    </div>
                                    <div style={{ cursor: 'pointer' }}>
                                        <TextField
                                            className="invoice_field"
                                            id="remarks"
                                            label="Remarks"
                                            variant="outlined"
                                            value={remarks}
                                            onChange={handleRemarksChange}
                                            sx={{ width: 200 ,background:'white' }}
                                            disabled={selectedDateType?.value === 'actual_date_update'}
                                            />

                                    </div>
                                    <div><button className="save_button" onClick={handleGeneratePOClick}>Save</button></div>
                                </div>
                        </div>

                        <Box sx={{ height: '100%', width: '100%', marginBottom: '1.5rem', marginTop: '10px' }}>
                            <DataGrid
                               autoHeight
                                className="table_header_background"
                                headerClassName="custom-header-cell"
                                getRowHeight={() => 'auto'}
                                rows={selectedPo ? approvalrows.filter(el => el.erp_po_no == selectedPo.label) : approvalrows}
                                columns={columns}
                                loading={gridLoad}

                                // initialState={{
                                //     pagination: {
                                //         paginationModel: {
                                //             pageSize: 5,
                                //         },
                                //     },
                                // }}
                                // pageSizeOptions={[5]}
                                disableRowSelectionOnClick
                                disableColumnMenu
                                disableColumnResize={true}
                                componentsProps={{
                                    cell: {
                                        disableClick: true,
                                    },
                                }}
                                sx={{
                                    '& .MuiDataGrid-cell': {
                                        '& .MuiDataGrid-cell--textOverflow': {
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        },
                                    },
                                }}
                            />
                        </Box>
                    </div>
                </Container>
            </div>
 
            <SweetAlert
                show={isOpenSweetAlert && isPOGenerationSuccess}
                title='Record updated successfully'
                success
                confirmButtonText="Ok"
                confirmBtnBsStyle="success"
                onConfirm={handleSweetAlertConfirm} // Updated to handleSweetAlertConfirm function

            />

            <SweetAlert
                show={isOpenSweetAlert && !isPOGenerationSuccess}
                title="Couldn't update record at this moment"
                error
                confirmButtonText="Close"
                confirmBtnBsStyle="error"
                onConfirm={handleSweetAlertConfirm} // Updated to handleSweetAlertConfirm function
            />
        </React.Fragment>
    );
};

export default UpdateVendorDate;
